import Vue from 'vue'
import VueRouter from 'vue-router'
import RouteMeta from '../model/RouteMeta'
import {RouteEffectTypes, AuthTypes} from '../enum'
import utils from '../utils'

const {getLocalItem, setLocalItem, parseQuery} = utils

/**
 * 路由服务，初始化路由加载导航钩子(放在最后执行，优先执行开发定义的钩子)
 * @class RouterService
 */
export default class RouterService{
	
	/**
	 * @constructor
	 * @param {Object<Router> router}
	 */
	constructor(router, routerConfig) {
		this.router = router
		this.config = routerConfig
		this.vueInstance = null
		this.overwrites(router)
	    router.beforeEach(routerGlobalBefore.bind(this))
		router.afterEach(routerGlobalAfter.bind(this))
		
		window.onpopstate = function(){}
	}
	
	setVueInstance(vueInstance){
		vueInstance && (vueInstance instanceof Vue) && (this.vueInstance = vueInstance)
	}
	
	overwrites(router){
		const push = VueRouter.prototype.push, replace = VueRouter.prototype.replace
		VueRouter.prototype.push = function(location, onResolve, onReject){
			push.call(router, location, onResolve, onReject).catch(err => {})
		}
		VueRouter.prototype.replace = function(location, onResolve, onReject){
			replace.call(router, location, onResolve, onReject).catch(err => {
				console.log(err)
			})
		}
	}
	
	readly(){
		this.vueInstance && this.vueInstance.$store.commit('mobileStore/removeRouterEffect', {
			trigger: Math.random()
		})
	}
}

/**
 * 定义全局beforeEach钩子、让导航开始执行页面切换动画
 * @param {Object<Route>} to
 * @param {Object<Route>} from
 * @param {Function} next
 */

async function routerGlobalBefore(to, from, next){
	const {path: toPath = '', meta: toMeta = {}} = to
	const {path: fromPath = '', meta: fromMeta = {}} = from
	const {$auth} = (await getInstance(this))
	const {effect = RouteEffectTypes.NONE} = toMeta
	const vueInstance = this.vueInstance
	const code = parseQuery('code')
	setLocalItem('session_code', code)
	if(toMeta.auth){
		switch(toMeta.auth){
			case AuthTypes.H5: {
				$auth.h5Auth({to, next})
				break
			};
			case AuthTypes.WX: {
				$auth.wxAuth(code)
				break
			};
		}
	}
	vueInstance && vueInstance.$clearStick && vueInstance.$clearStick()
	doEffect.call(this, effect, next)
}

/**
 * 定义全局afterEach钩子
 * @param {Object<Route>} to
 * @param {Object<Route>} from
 */
function routerGlobalAfter(to, from){
	const {meta: {title = ''}} = to
	const {afterEach: userDefinedAfterRouter} = this.config
	title && (document.title = title) //<= 注意IOS微信不支持动态修改document.title
	userDefinedAfterRouter && userDefinedAfterRouter(to, from, this.vueInstance)
}

function getInstance(instance){
	if(instance.vueInstance === null){
		return new Promise((res, rej) => {
			setTimeout(() => {
				res(instance.vueInstance)
			}, 200)
		})
	}else{
		return instance.vueInstance
	}
}

function doEffect(effect, next){
	const {vueInstance} = this
	
	switch(effect){
		case RouteEffectTypes.NONE: {
			next()
		};
		case RouteEffectTypes.SLIDER_LEFT: {
			Vue.$next = next
			vueInstance.$store.commit('mobileStore/setRouterEffect', {
				trigger: Math.random(),
				effect
			})
		}
	}
}